// extracted by mini-css-extract-plugin
export default {"main":"src-views-___ready-to-pin__main____UT39","title":"src-views-___ready-to-pin__title___kf6I6"};